import { m as map, c as compact, f as fromPredicate } from './Either-48abb652.js';
import { p as pipe } from './ReadonlyNonEmptyArray-0e481d0b.js';
import { u as unfoldTree, f as fromTraversable, P as Prism, L as Lens, t as tree } from './index-a60c253d.js';
import './ReadonlyRecord-86a56753.js';
import './string-40bcd6bf.js';

const getExtractor = (nodesAccessor) => (root) => {
  class TraversalExtractor {
    constructor(traversal, tree2) {
      this.traversal = traversal;
      this.tree = tree2;
    }
    filter(predicate) {
      return new TraversalExtractor(
        this.traversal.composePrism(Prism.fromPredicate(predicate)),
        this.tree
      );
    }
    map(mapper) {
      return new TraversalExtractor(
        this.traversal.composeLens(new Lens(mapper, () => (dt) => dt)),
        this.tree
      );
    }
    chain(mapper) {
      return pipe(this.get(), map(mapper));
    }
    get() {
      return pipe(
        this.traversal.asFold().getAll(this.tree),
        map(fromPredicate(Boolean)),
        compact
      );
    }
  }
  const tree$1 = unfoldTree(root, (node) => [node, nodesAccessor(node)]);
  return new TraversalExtractor(fromTraversable(tree)(), tree$1);
};

export { getExtractor };
//# sourceMappingURL=extractor-infra.js.map
